var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWefLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-58 -17.3 239 153",
    style: {
      enableBackground: "new -58 -17.3 239 153"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,6.7c-0.3-1.1-0.5-2.4-0.5-3.5c0-5.4,3.5-10,10-10c1.3,0,2.7,0.3,3.8,0.5c1.1-0.8,2.4-1.9,3.5-2.7 c-2.2-1.3-4.6-1.9-7.3-1.9c-7.8,0-14.6,6.2-14.6,14c0,2.7,0.8,5.4,2.2,7.6c0.3-0.5,0.5-1.1,1.1-1.3C22.1,8.3,22.7,7.5,23.2,6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4-7.3c-1.1,0.8-2.2,1.6-3.2,2.4C41.6-3,42.6,0,42.6,3.2c0,5.4-4,10-10,10c-3.5,0-6.2-1.3-7.8-3.8 c-0.3,0.5-0.8,0.8-1.1,1.3c-0.5,0.8-1.1,1.3-1.3,2.2c2.7,2.7,6.2,4.3,10.5,4.3c8.1,0,14.6-5.9,14.6-14C47.2-1.1,45.3-4.6,42.4-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,39.6c0,4.3-2.4,7.8-6.2,9.4c0,0.8,0,1.6,0,2.4c0,0.5,0,1.3,0,1.9c6.2-1.6,10.8-6.7,10.8-13.5 c0-4.9-2.7-9.2-6.7-11.9c-0.5,1.3-0.8,2.7-1.3,3.8C15.9,33.7,17,36.4,17,39.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,49.6c-0.3,0-0.5,0-0.8,0c-5.9,0-10-4.6-10-10s3.5-10,10-10c1.6,0,2.7,0.3,4,0.8c0.3-1.3,0.8-2.4,1.3-3.8 c-1.6-0.5-3.5-1.1-5.1-1.1c-7.8,0-14.6,6.2-14.6,14c0,8.1,6.5,14,14.6,14c0.3,0,0.5,0,0.8,0c0-0.8,0-1.6,0-2.4 C7.8,50.7,7.8,50.2,7.8,49.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,66.3c6.5,0,10,4.9,10,10c0,4.6-3,8.6-7.3,9.7c0.8,1.1,1.3,2.4,2.2,3.5c5.7-1.9,9.7-7,9.7-13.2 c0-7.8-6.5-14-14.6-14c-1.9,0-3.8,0.3-5.7,1.1c0.3,1.3,0.5,2.7,0.8,4C14,66.6,15.7,66.3,17.3,66.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.3,76.3c0-2.7,1.1-5.4,2.7-7.3c-0.3-1.3-0.8-3-1.1-4.3c-3.8,2.4-6.2,6.7-6.2,11.6c0,8.1,6.5,14,14.6,14 c0.5,0,1.3,0,1.9,0c-0.8-1.3-1.6-2.4-2.4-3.8C11.1,86,7.3,81.7,7.3,76.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.1,107.3c-13.5,11.1-30.5,17-48,17c-17.8,0-35.3-6.2-48.8-17.8l-2.2,2.4c14.3,11.9,32.4,18.6,51,18.6 c18.3,0,36.2-6.2,50.2-17.8L131.1,107.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,62.8V79c0,3.8-1.3,7.3-5.9,7.3c-4.9,0-5.9-3.5-5.9-7.3V62.8h-4.3v17c0,5.9,3.8,10.5,10.5,10.5 c6.7,0,10.5-4.6,10.5-10.5v-17H87.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "90.9,12.6 103.1,12.6 103.1,16.4 86.6,16.4 86.6,-10.6 90.9,-10.6 90.9,12.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "-58,26.1 -42.4,26.1 -42.4,30.2 -53.7,30.2 -53.7,36.4 -42.6,36.4 -42.6,40.4 -53.7,40.4 -53.7,49.1  -42.4,49.1 -42.4,53.1 -58,53.1 -58,26.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "30.5,24.8 49.1,43.7 49.1,26.1 53.4,26.1 53.4,54.2 35.1,35.3 35.1,53.1 30.5,53.1 30.5,24.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.1,
    y: 26.1,
    className: "st0",
    width: 4.3,
    height: 27
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "-14.6,66.6 -14.6,73.1 -5.1,73.1 -5.1,77.1 -14.6,77.1 -14.6,89.8 -19.1,89.8 -19.1,62.8 -4.8,62.8  -4.8,66.6 -14.6,66.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.2,6.4 3.2,6.4 7.6,-10.6 11.9,-10.6 4.3,17.5 -5.1,-2.7 -14.6,17.5 -22.1,-10.6 -17.8,-10.6  -13.5,6.4 -13.5,6.4 -5.1,-11.1 3.2,6.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "106,36.1 106,36.1 101.7,53.1 97.4,53.1 105,25.1 114.4,45.3 123.8,25.1 131.4,53.1 127.1,53.1  122.8,36.1 122.8,36.1 114.4,53.7 106,36.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "108.5,72.8 108.5,72.8 104.2,89.8 99.8,89.8 107.4,61.8 116.8,82 126.3,61.8 133.8,89.8 129.5,89.8  125.2,72.8 125.2,72.8 116.8,90.4 108.5,72.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.6,62.8c2.4,0,5.4,0,7.6,1.3c2.4,1.3,3.5,3.8,3.5,6.5c0,3.8-2.7,7-6.7,7.6l8.6,11.6h-5.1l-8.1-11.3h-3v11.3 H41v-27L48.6,62.8 M45.6,75h2.2c3.5,0,7.6,0,7.6-4.3s-4.6-4-7.8-4h-1.9L45.6,75L45.6,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.7-10.6c2.4,0,5.4,0,7.6,1.3c2.4,1.3,3.5,3.8,3.5,6.5c0,3.8-2.7,7-6.7,7.6l8.6,11.6H72L64,5.1h-3v11.3h-4.3 v-27L63.7-10.6 M60.7,1.6h2.2c3.5,0,7.6,0,7.6-4.3s-4.6-4-7.8-4h-1.9L60.7,1.6L60.7,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.5,12.6h2.7c5.9,0,11.6-2.2,11.6-9.7c0-7.8-5.7-9.7-11.6-9.7h-2.7V12.6 M110.9-10.6h7.3 c8.4,0,15.4,4,15.4,13.2c0,9.4-6.7,13.5-15.6,13.5h-7.3v-26.7H110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.8,48.5c-1.3,0.8-3,1.1-4.9,1.1c-5.9,0-10-4.6-10-10s3.5-10,10-10c1.9,0,3.5,0.5,4.9,1.1l2.2-3.2 c-2.2-1.1-4.6-1.9-7.3-1.9c-7.8,0-14.6,6.2-14.6,14c0,8.1,6.5,14,14.6,14c2.7,0,5.1-0.5,7.3-1.9L174.8,48.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-14.6,48.5c-1.3,0.8-3,1.1-4.9,1.1c-5.9,0-10-4.6-10-10s3.5-10,10-10c1.9,0,3.5,0.5,4.9,1.1l2.2-3.2 c-2.2-1.1-4.6-1.9-7.3-1.9c-7.8,0-14.6,6.2-14.6,14c0,8.1,6.5,14,14.6,14c2.7,0,5.1-0.5,7.3-1.9L-14.6,48.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.3,106.8c-13.2,10.8-29.9,16.7-47.2,16.7c-19.7,0-38.3-7.6-52.3-21c-14-13.8-21.6-31.8-21.6-51 c0-14.8,4.6-29.1,13.2-41.3C31-1.7,42.6-10.6,56.7-16l-0.5-1.3C42.1-11.9,30-2.7,21.3,9.4c-8.9,12.4-13.5,27-13.5,42.1 c0,19.7,7.8,38,22.1,52.1c14.3,14,33.2,21.6,53.2,21.6c17.5,0,34.8-5.9,48.3-17L130.3,106.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,39.6c0-5.4-3.5-10-10-10c-6.5,0-10,4.9-10,10c0,5.4,4,10,10,10C83.1,49.6,87.2,45,87.2,39.6 M91.7,39.6 c0,8.1-6.5,14-14.6,14s-14.6-5.9-14.6-14c0-7.8,6.5-14,14.6-14C85,25.6,91.7,31.8,91.7,39.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWefLogo);
export default __webpack_public_path__ + "static/media/wef_logo.fc2d6424bea59411ab103470b5de79db.svg";
export { ForwardRef as ReactComponent };